/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from 'react'
import {
  getPomodoroConfig,
  addPomodoroSessionFocusSeconds,
  addPomodoroSessionFocusTime,
  createPomodoroConfig,
  deletePomodoroConfig,
  createPomodoroSession,
  updatePomodoroSession,
} from '@services'

const usePomodoro = () => {
  // Busca as configurações salvas
  const fetchPomodoroConfig = () => getPomodoroConfig()

  // Cria uma nova configuração de Pomodoro
  const createNewConfig = (data) => createPomodoroConfig(data)

  // Deleta uma configuração de Pomodoro
  const deleteConfig = (id) => deletePomodoroConfig(id)

  // Inicia uma sessão de Pomodoro (registra no histórico)
  const startPomodoro = (configId) => {
    return createPomodoroSession({
      configId,
      status: 'EM_ANDAMENTO',
      focusTime: 0,
    })
  }

  // Finaliza uma sessão de Pomodoro
  const finishPomodoro = (sessionId, focusTimeMinutes = null) => {
    const updates = {
      status: 'CONCLUIDO',
      dataFim: new Date().toISOString(),
    }

    if (focusTimeMinutes != null) {
      updates.focusTime = focusTimeMinutes
    }

    return updatePomodoroSession(sessionId, updates)
  }

  const addFocusTimeToPomodoro = (sessionId, focusTimeMinutes) =>
    addPomodoroSessionFocusTime(sessionId, focusTimeMinutes)

  const addFocusSecondsToPomodoro = (sessionId, focusSeconds) =>
    addPomodoroSessionFocusSeconds(sessionId, focusSeconds)

  return useMemo(
    () => ({
      getPomodoroConfig: fetchPomodoroConfig,
      createPomodoroConfig: createNewConfig,
      deletePomodoroConfig: deleteConfig,
      startPomodoro,
      finishPomodoro,
      addFocusTimeToPomodoro,
      addFocusSecondsToPomodoro,
    }),
    []
  )
}

export { usePomodoro }
